export function directSaleEstimate(priceCents: number, platformRate: number, processingPercent: number, fixedProcessingCents: number) {
  if (![priceCents, platformRate, processingPercent, fixedProcessingCents].every(Number.isFinite) || !Number.isInteger(priceCents) || priceCents < 0 || platformRate < 0 || platformRate > 1 || processingPercent < 0 || processingPercent > 100 || fixedProcessingCents < 0) throw new RangeError('Invalid fee assumption');
  const platformCents = Math.round(priceCents * platformRate);
  const processingCents = Math.round(priceCents * processingPercent / 100) + Math.round(fixedProcessingCents);
  const netCents = Math.max(0, priceCents - platformCents - processingCents);
  return { grossCents: priceCents, platformCents, processingCents, netCents };
}
export function effectiveRoyaltyRate(earnings: number, units: number): number | null {
  return Number.isFinite(earnings) && earnings > 0 && Number.isSafeInteger(units) && units > 0 ? earnings / units : null;
}
export function royaltyUnitsToEqual(netCents: number, rate: number | null): number | null {
  if (!Number.isFinite(netCents) || netCents < 0 || rate === null || !Number.isFinite(rate) || rate <= 0) return null;
  const result = Math.ceil((netCents / 100) / rate);
  return Number.isSafeInteger(result) ? result : null;
}
